import { env } from '@repo/env';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export const WPBlock = async (doc: StructuredContentDocument) => {
  if (!doc.props.id) {
    const environment = env.NEXT_PUBLIC_DEPLOYABLE_ENV;
    if (environment === 'stage' || environment === 'dev') {
      console.warn(
        `WPBlock Structured Content Renderer missing content for doc id: ${doc.props.id}`,
      );
    }
    return null;
  }

  return <StructuredContentRenderer doc={doc.props.content} />;
};
